import { render, staticRenderFns } from "./tabPopover.vue?vue&type=template&id=254d080e"
import script from "./tabPopover.vue?vue&type=script&lang=js"
export * from "./tabPopover.vue?vue&type=script&lang=js"
import style0 from "./tabPopover.vue?vue&type=style&index=0&id=254d080e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.26_css-loader@6.11.0_webpack@5.104.1__lodash@4_dadc69c0c314c10718e831924e2cd7d9/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports